import { useFeatureFlag } from '@fs/zion-flags'
import { useLocation } from '@fs/zion-router'
import { US_CENSUS_CMS_COLLECTION_IDS } from './collectionConstants'
import { getCollectionIdFromPathname } from './collectionHelpers'

export default function useCmsCollectionGating() {
  // Since search_cmsCollectionsHr was removed (FSS-14861), HR collection pages are unconditional —
  // this flag no longer affects them. It now only gates non-HR surfaces: the full-text and tree
  // collection detail routes (App.js), and the Internet Collections card on Location pages.
  const cmsCollectionsFlag = useFeatureFlag('search_cmsCollections')
  const { pathname } = useLocation()

  // Whether to embed the wiki about section (census always excluded). The id is resolved the same
  // way the collection detail providers resolve it, so /1940census — which has no :collectionId
  // param — is still recognized as a census collection.
  const shouldEmbedWikiAbout = (id) => !US_CENSUS_CMS_COLLECTION_IDS.has(getCollectionIdFromPathname(pathname, id))

  return { cmsCollectionsFlag, shouldEmbedWikiAbout }
}
